import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';
import ProductName from './component/ui/ProductName';
import AppName from './component/ui/AppName';
import AppLogoImage from './component/ui/AppLogoImage';
import AppFavicon from './component/ui/AppFavicon';
import AppHeader from './component/ui/AppHeader';

class SettingUICustomization extends React.Component {
	componentDidMount() {
		this.props.fetchSettingDataInfo()
	}

	onSaveProductName = (value) => {
		this.props.fetchSettingDataUpdate(value, {
			key: this.props.settingKey.productName.value,
			settingListMap: value
		});
	}

	onSaveAppName = (value) => {
		const params = this.props.settingKey?.appName?.keyList.map((item) => {
			const currentKey = item.value;
			const currentValue = value.data[currentKey];

			return {
				key: currentKey,
				value: currentValue !== undefined ? currentValue : ""
			};
		});

		this.props.fetchSettingDataUpdate(params, {
		});
	}

	onSaveAppLogoImage = (value) => {
		const { appLogoImage } = this.props.settingKey;
		const { uiCustomizationData } = this.props;
		const customizationData = uiCustomizationData || {};

		const params = appLogoImage.keyList.reduce((paramList, item) => {
			const currentKey = item.value;
	
			if (!(currentKey in value) && customizationData[currentKey] !== null) {
				return paramList;
			}
	
			paramList.push({
				key: currentKey,
				value: value[currentKey] || ""
			});
			return paramList;
		}, []);

		params.push({
			key: 'appLogoImageOption',
			value: value.appLogoImageOption,
		});

		if (value.appLogoImageOption == 1 || value.appLogoImageOption == 2) {
			params.push({
				key: appLogoImage.value,
				value: ''
			})
		}
		if (value.appLogoImageOption == 0 && !isEmpty(value.appLogoImage)) {
			params.push({
				key: appLogoImage.value,
				value: value.appLogoImage
			})
		} else if(value.appLogoImageOption == 0 && value.appLogoImage == '') {
			params.push({
				key: appLogoImage.value,
				value: value.appLogoImage
			})
		}

		this.props.fetchSettingDataUpdate(params, {
		});
	}

	onSaveAppFaviconImage = (value) => {
		const { appFavicon } = this.props.settingKey;
		const { uiCustomizationData } = this.props;
		const customizationData = uiCustomizationData || {};

		const params = appFavicon.keyList.reduce((paramList, item) => {
			const currentKey = item.value;
	
			if (!(currentKey in value) && customizationData[currentKey] !== null) {
				return paramList;
			}
	
			paramList.push({
				key: currentKey,
				value: value[currentKey] || ""
			});
			return paramList;
		}, []);

		params.push({
			key: 'appFaviconImageOption',
			value: value.appFaviconImageOption,
		});

		if (value.appFaviconImageOption == 1) {
			params.push({
				key: appFavicon.value,
				value: ''
			})
		}

		if (value.appFaviconImageOption == 0 && !isEmpty(value.appFaviconImage)) {
			params.push({
				key: appFavicon.value,
				value: value.appFaviconImage
			})
		} else if(value.appFaviconImageOption == 0 && value.appFaviconImage == '') {
			params.push({
				key: appFavicon.value,
				value: value.appFaviconImage
			})
		}

		this.props.fetchSettingDataUpdate(params, {
		});
	}

	onSaveAppHeader = (value) => {
		this.props.fetchSettingDataUpdate(value, {
			key: this.props.settingKey.appHeader.value,
			settingListMap: value
		});
	}

	render() {
		const { t } = this.props;
		const { uiCustomizationData } = this.props;
		const customizationData = uiCustomizationData || {};
		const licensePublisher = customizationData.publisher;
		const TFL = "TF";
		const pwlCheck = customizationData.isPWL;

		// PWL 조건 체크 (TFL 라이선스이고, PWL 인 경우는 전체 설정 볼 수 있음 / 한컴 라이선스 경우 App Header 만)
		const isPWL = licensePublisher === TFL && pwlCheck;
		return (
			<div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
				{isPWL ? (
					<>
						<ProductName
							t={this.props.t}
							settingKey={this.props.settingKey.productName}
							settingData={customizationData.productName}
							onSave={this.onSaveProductName}
						/>
						<AppName
							t={this.props.t}
							settingKey={this.props.settingKey.appName}
							settingData={customizationData}
							onSave={this.onSaveAppName}
						/>
						<AppLogoImage
							t={this.props.t}
							settingKey={this.props.settingKey.appLogoImage}
							settingData={customizationData}
							alertMessage={this.props.alertMessage}
							onSave={this.onSaveAppLogoImage}
							setShowLogoPanel={this.setShowLogoPanel}
						/>
						<AppFavicon
							t={this.props.t}
							settingKey={this.props.settingKey.appFavicon}
							settingData={customizationData}
							alertMessage={this.props.alertMessage}
							onSave={this.onSaveAppFaviconImage}
						/>
						<AppHeader
							t={this.props.t}
							settingHeaders={this.props.settingHeaders}
							settingKey={this.props.settingKey.appHeader}
							settingData={customizationData}
							onSave={this.onSaveAppHeader}
						/>
					</>
				) : (
					<AppHeader
						t={this.props.t}
						settingHeaders={this.props.settingHeaders}
						settingKey={this.props.settingKey.appHeader}
						settingData={customizationData}
						onSave={this.onSaveAppHeader}
					/>
				)}

				{isPWL && (
					<div style={{ width: '100%', paddingLeft: '24px', paddingRight: '24px'}}>
						<hr className="section_hr" />
						<div style={{ 
							textAlign: 'left',
							fontSize: '18px',
							wordWrap: 'break-word' 
							}}>
							<i>{t('setting.terms')}</i>
						</div>
					</div>
				)}
			</div>
		);
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {
		uiCustomizationData: reducers.setting.uiCustomizationData,
		settingKey: reducers.setting.settingKey,
		settingData: reducers.setting.settingData,
		settingHeaders: reducers.setting.settingHeaders,
		apiCalling: reducers.apiCalling.apiCalling,
	}
}

// 컴포넌트의 함수형 props 를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		fetchSettingDataInfo: (key) => dispatch({ type: types.FETCH_GET_UI_CUSTOMIZATION_REQUEST, key }),
		fetchSettingDataUpdate: (value, params) => dispatch({ type: types.FETCH_SET_UI_CUSTOMIZATION_REQUEST, value, params }),
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SettingUICustomization))